'use strict';

function expandIngredient() {
    $('.js-expand-collection-ingredients').off('click').on('click', function () {
        const $ingredientsBlock = $(this).closest('.js-collection-ingredients');
        const $ingredientItem = $ingredientsBlock.find('.js-collection-text-holder .js-collection-ingredient-col');
        if (!$ingredientsBlock.hasClass('open')) {
            $ingredientsBlock.addClass('open');
            $ingredientItem.stop().show();
        } else {
            $ingredientsBlock.removeClass('open');
            $ingredientItem.not(':first').stop().slideUp(400);
            $('html, body').animate({scrollTop: ($ingredientsBlock.offset().top - 60)}, 400);
        }
    });
}

/**
* @description Initialize block
*/
function initBlock() {
    expandIngredient();
}

const collectionIngredients = {
    init: function() {
        // if ingredients block exists, init
        if ($('.js-collection-ingredients').length > 0){
            initBlock();
        }
    }
};

module.exports = collectionIngredients;
